<template>
  <div>
    <!-- 出厂检验可视化 -->
  <div style="display:flex;justify-content:space-between" class="fac_line" v-if="!zeroFlag">
      <div>
        <el-tooltip effect="redTip" placement="top">
          <span>
            <span style="font-weight: 600;color:#1D2129;">{{ h_i18n('b96626929870187c15891ac9d25e6dc8') }}</span>
            <!-- <help theme="outline" size="13" style="color:#2681FF;cursor: pointer;
            position: relative;top: 2px; line-height: 15px; height: 15px;" /> -->
            <i class="el-icon-warning-outline" style="color:#2681FF;cursor: pointer;font-size: 16px;" ></i>
          </span>
         
          <template #content>
            <span>{{ h_i18n('cd38545e4f2c9cfe5b09d37f9dd91d7b') }}<br/>{{ h_i18n('96d5c39ce6bf11bce733a9d65b75b878') }}</span>
          </template>
        </el-tooltip>
        <span style="margin-left:16px;color:#86909C" v-if="zeroFlag">{{ h_i18n('b13d24b2a36318f6120a1b039770b6a7') }}</span>
        <span style="margin-left:16px;color:#86909C" v-else>{{ h_i18n('7c98ddedde170cc8e6431e0d3abfffa1') }}</span>
      </div>
    <div class="fac_flex" v-if="isEditOrAddFlag">
        <span style="color:#F53F3F;">{{ h_i18n('d8132b6ff9de49ff14f218c1499ddac5') }}</span>
        <h-button size="mini" type="primary" @click="saveTemp('pic')" style="margin-top: 6px;">{{ h_i18n('d8acae3bcfbc9ec9ade58c2dbacf65aa') }}</h-button>
    </div>
  </div>
  <!-- 厂区地址选择 -->
  <div>
    <div class="fac_line" v-if="isEditOrAddFlag" >{{ h_i18n('5e4b94e87bb08d0e5e199e9b5f84be6a') }}
      <!-- <span style="color:red">{{ h_i18n('14025c39e6de242da9a7e8f223e5ba82') }}</span> -->
      <!-- ②天眼供应商厂区地址备注修改“维护厂区地址”，为超链接样式跳转“出厂天眼可视”； -->
      <div style="width: 16px; display: inline-block;"></div>
      <!-- 维护厂区地址 -->
      <span class="blueClick" @click="navigateTo()">{{h_i18n('6E0110528E9D6EDA9E48FBDA4F1EB61C')}}</span>
    </div>
    <div v-else class="fac_line">{{ h_i18n('62ce054c84151740fa64d0064b7a9b3f') }}</div>
    <div v-if="isEditOrAddFlag">
      <el-select v-model="newAddData.factoryAddressNewId" filterable :placeholder="h_i18n('02a2914b91cc408cbde118bc04eb2260')"
        style="width:95%;margin-left: 15px;" @change="factoryAddressChange">
        <el-option v-for="item in factoryData" :key="item.id" :label="item.fullAddress" :value="item.id"
          @click="clickUserJumpIdState(item.id)">
        </el-option>
      </el-select>
    </div>
    <div v-else>
      <el-input v-if="paramsData" style="width:98%;margin-left: 15px;" disabled v-model="address">
      </el-input>
    </div>
  </div>
  <div v-if=" !zeroFlag && isEditOrAddFlag" class="fac_flex">
    <div style="margin-right:112px">
      <div class="fac_line">{{ h_i18n('7363e486b45c9f193be34efcdf6f6f01') }}<span style="color:red;">*</span></div>
      <div class="fac_flex">
        <div style="border:1px solid #E5E6EB;border-radius:4px;width:384px;height:190px;    text-align: center;" v-loading="imgUpLoading1" :empty-text="h_i18n('fc09a73e52b76f697cff129b4dddecd1')">
            <el-image :src="$filePathSplicing(picUrl2, 'img')" :fit="contain"
              style="width:376px;height:182px;margin:4px"
              :preview-src-list="picUrl2List.map(item => $filePathSplicing(item, 'img'))">
              <template #error>
                <Picture style="width:80px;color: #ccc;padding-top: 35px;padding-bottom:35px" />
              </template>
            </el-image>
        </div>
        <div style="margin-left: 20px;">
          <div @click="btnCantUse" style="display: flex;height: 100%;display: flex;flex-flow: column;justify-content: end">
            <h-button type="primary" size="mini" :disabled="btnCanUse" @click="btnPhotoLater(2)" style="margin-bottom: 16px;"
              :loading="loadingFlag60S2">{{ btnNameOf2 }}{{ getCode2 }}</h-button>
            <h-button style="margin-bottom: 16px;" type="primary" size="mini" :disabled="btnCanUse" @click="btnPhotoNow(2)"
              :loading="loadingFlagNow2">{{ h_i18n('fd4a2caddedee481431a40b713cf3615') }}</h-button>
            <h-button type="danger" size="mini" @click.stop="deletePhoto(2)">{{ h_i18n('c18fba5e008b2b9b81a5dc4a759828ba') }}</h-button>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="fac_line">{{ h_i18n('6fe491072e0a54c39fc371ba29bca1e6') }}<span style="color:red;">*</span></div>
      <div class="fac_flex">
        <div style="border:1px solid #E5E6EB;border-radius:4px;width:384px;height:190px;    text-align: center;" v-loading="imgUpLoading2" :empty-text="h_i18n('fc09a73e52b76f697cff129b4dddecd1')">
          <el-image style="width:376px;height:182px;margin:4px" :src="$filePathSplicing(picUrl3, 'img')" :fit="contain"
          :preview-src-list="picUrl3List.map(item => $filePathSplicing(item, 'img'))">
          <template #error>
            <Picture style="width:80px;color: #ccc;padding-top:35px;" />
          </template>
        </el-image>

        </div>
        <div style="margin-left: 20px;">
          <div @click="btnCantUse" style="display: flex;height: 100%;display: flex;flex-flow: column;justify-content: end">
            <h-button style="margin-bottom: 16px;" type="primary" size="mini" :disabled="btnCanUse" @click="btnPhotoLater(3)"
              :loading="loadingFlag60S3">{{ btnNameOf3 }}{{ getCode3 }}</h-button>
            <h-button style="margin-bottom: 16px;" type="primary" size="mini" :disabled="btnCanUse" @click="btnPhotoNow(3)"
              :loading="loadingFlagNow3">{{ h_i18n('fd4a2caddedee481431a40b713cf3615') }}</h-button>
            <h-button type="danger" size="mini" @click.stop="deletePhoto(3)">{{ h_i18n('c18fba5e008b2b9b81a5dc4a759828ba') }}</h-button>
          </div>
        </div>
      </div>
    </div>
    <div style="width:100px !important;height:100px !important;overflow: hidden;display: none;">
          <div id="video-container"></div>
        </div>
  </div>
  <div v-if=" !zeroFlag && !isEditOrAddFlag" class="fac_flex">
    <div style="margin-right:112px">
      <div class="fac_line">{{ h_i18n('7363e486b45c9f193be34efcdf6f6f01') }}<span style="color:red;">*</span></div>
      <div class="fac_flex">
        <div style="border:1px solid #E5E6EB;border-radius:4px;width:384px;height:190px;    text-align: center;" v-loading="imgUpLoading1" :empty-text="h_i18n('fc09a73e52b76f697cff129b4dddecd1')">
            <el-image style="width:376px;height:182px;margin:4px"
              :src="paramsData ? $filePathSplicing(paramsData.componentsSamplePhotoUuid, 'img') : ''" :fit="contain"
              :preview-src-list="paramsData ? [paramsData.componentsSamplePhotoUuid].map(item => $filePathSplicing(item, 'img')) : []">
              <template #error>
                <Picture style="width:80px;color: #ccc;padding-top: 35px;padding-bottom:35px" />
              </template>
            </el-image>
        </div>
      </div>
    </div>
    <div>
      <div class="fac_line">{{ h_i18n('6fe491072e0a54c39fc371ba29bca1e6') }}<span style="color:red;">*</span></div>
      <div class="fac_flex">
        <div style="border:1px solid #E5E6EB;border-radius:4px;width:384px;height:190px;    text-align: center;" v-loading="imgUpLoading2" :empty-text="h_i18n('fc09a73e52b76f697cff129b4dddecd1')">
        <el-image style="width:376px;height:182px;margin:4px"
        :src="paramsData ? $filePathSplicing(paramsData.componentsInspectionPocessPhotoUuid, 'img') : ''" :fit="contain"
        :preview-src-list="paramsData ? [paramsData.componentsInspectionPocessPhotoUuid].map(item => $filePathSplicing(item, 'img')) : []">
        <template #error>
          <Picture style="width:80px;color: #ccc;padding-top:35px;padding-bottom:35px" />
        </template>
      </el-image>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import { assertLiteral } from '@babel/types'
import { Picture } from '@element-plus/icons'
import EZUIKit from 'ezuikit-js'
var player = null
export default {
  components: { Picture },
  props: ['paramsData', 'starFlag', 'zeroFlag'],
  data() {
    return {
      address: null,
      supplyCode: null, // 根据供应商码获取厂区地址
      newAddData: { // 新增天眼截图时，增加的提交内容
        factoryAddressNew: null,
        factoryAddressNewId: null,
        samplePhotoUuid: null, // 抽样照片uuid
        samplePhoto: null,
        inspectionPocessPhotoUuid: null, //检验过程照片 uuid
        inspectionPocessPhoto: null,
      },
      factoryData: [], // 厂区地址选择列表
      getCode2: '',
      getCode3: '', // 秒数
      loadingFlag60S2: false,
      loadingFlag60S3: false,// 延时按钮loading
      loadingFlagNow2: false,
      loadingFlagNow3: false, //即时按钮loading
      btnNameOf3: h_i18n('2cfd7acbb504355432476d6c34f491b1'),
      btnNameOf2: h_i18n('2cfd7acbb504355432476d6c34f491b1'), //按钮显示文字
      countDown2: null, // 异步id
      countDown3: null,
      hasPhoto2: false,// 有无照片
      hasPhoto3: false,
      photoTimeOf2: null, // 照片时间
      photoTimeOf3: null,
      picUrl2: null, // 截图
      picUrl3: null,
      picUrl2List: [], // 预览图
      picUrl3List: [],
      videoUrl: null,
      videoAccessToken: null,
      VideoStatus: h_i18n('fd6e80f1e0199d6ecc3ee81ae04aa9ef'),
      btnCanUse: true, // 控制截图按钮是否可用
      iframeOfSrc: null, // iframe的Src
      videoFlag: false, // 视频是否成功
      backFactoryId: null, // 取消时改回上一个工厂地址
      flag: null,
      //
      // zeroFlag:true, // 30天无不合格，取消照片关联
      searchData: {},
      isEditOrAddFlag: false, // 是否可编辑
      picUrl2OfBack: null, // 回显照片
      picUrl3OfBack: null, // 回显照片
      photoTimeOf2OfBack: null, // 回显时间
      photoTimeOf3OfBack: null, // 回显时间
      // select 再次点击同一条数据的处理
      tempfactoryId: null,
      imgUpLoading1:false,
      imgUpLoading2:false,
    }
  },
  methods: {
    h_i18n,
    // 通过 iframe 消息通知外层 Content/Header，非 iframe 场景保留 changeRouter 兜底。
    navigateTo(extraQuery = {}) {
      const safeQuery = extraQuery
        && Object.prototype.toString.call(extraQuery) === '[object Object]'
        ? extraQuery
        : {}
      const payload = {
        url: '/newproduct/VisualEye',
        routerName: h_i18n('f426a7bbab7ac4abd7d4b94e5817eee9'),
        headerRootId: 58,
        currentMenuId: 59,
        query: safeQuery
      }
      const message = {
        type: 'SQM_IFRAME_CHANGE_ROUTER',
        payload
      }

      if (window.parent && window.parent !== window) {
        window.parent.postMessage(message, '*')
        return
      }

      this.$emit(
        'changeRouter',
        payload.url,
        payload.routerName,
        payload.headerRootId,
        payload.currentMenuId,
        payload.query
      )
    },
    // 回调暂存
    saveTemp(value) {
      this.$emit('saveOfFacImgTemp', value)
    },
    getaddress() {
      if (!this.paramsData) {
        console.log('return Address')
        return
      }
      this.address = this.paramsData.componentsFactoryAddressNew || this.paramsData.componentsFactoryAddress || this.paramsData.backFactoryAddressNew || this.paramsData.backFactoryAddress
      // if(this.paramsData.componentsFactoryAddressNew){
      //   this.address = this.paramsData.componentsFactoryAddressNew 
      // }else if(this.paramsData.componentsFactoryAddress){
      //   this.address = this.paramsData.componentsFactoryAddress
      // }
      // if(this.paramsData.backFactoryAddressNew){
      //   this.address = this.paramsData.backFactoryAddressNew 
      // }else{

      // }
      console.log("this.address ", this.address)
    },
    /**
     * 厂区地址修改 factoryAddressChange
     * 修改后获取videoUrl和videoAccessToken
     */
    factoryAddressChange(factoryId) {
      if (this.$props.zeroFlag) {
        this.factoryData.forEach(item => {
          if (item.id == this.newAddData.factoryAddressNewId) {
            this.newAddData.factoryAddressNew = item.fullAddress
          }
        })
        // console.log(this.newAddData)
        this.$emit('shipmentfactoryevent', this.newAddData)
        return
      }
      // console.log("factoryAddressChange factoryId",factoryId)
      this.$emit('changeFunEmit', factoryId)
      if (factoryId) {
        // console.log(this.hasPhoto2,this.hasPhoto2)
        if (this.hasPhoto2 || this.hasPhoto3) {
          this.info({
            title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
            confirmButtonText: h_i18n('e83a256e4f5bb4ff8b3d804b5473217a'),
            cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
            message: h_i18n('5d63d228964ff1850ed0c734d1cdd8cd'),
            type: 'error',
            callback: (action) => {
              console.log(action, "----------------------------")
              if (action === "confirm") {
                this.startLoading(h_i18n('20be4e8754288a713b9ad759c78ba22b'))
                this.tempfactoryId = factoryId
                // console.log('确认了') 清除已拍照片
                this.picUrl2 = null
                this.picUrl3 = null
                this.picUrl2List = []
                this.picUrl3List = []
                this.hasPhoto2 = false
                this.hasPhoto3 = false
                this.photoTimeOf2 = null
                this.photoTimeOf3 = null
                this.changeFactoryData(factoryId)
                this.closeLoading()
              } else {
                this.factoryData.forEach(item => {
                  if (item.id == this.backFactoryId) {
                    this.newAddData.factoryAddressNew = item.fullAddress
                  }
                })
                this.newAddData.factoryAddressNewId = this.backFactoryId
                return
              }
            }
          })
        } else {
          this.tempfactoryId = factoryId
          this.changeFactoryData(factoryId)
        }
      }
    },
    clickUserJumpIdState(factoryId) {
      if (this.$props.zeroFlag) {
        return
      }
      if (factoryId == this.tempfactoryId && player) {
        // console.log("clickUserJumpIdState factoryId",factoryId)
        if (player) {
          player.stop()
        }
        this.loadingFlag60S3 = false
        this.getCode3 = ''
        this.btnNameOf3 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
        this.loadingFlag60S2 = false
        this.getCode2 = ''
        this.btnNameOf2 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
        this.btnCanUse = true
        clearInterval(this.countDown2)
        clearInterval(this.countDown3)
        this.initOfLive()
      }
      // console.log('play',player)
      // console.log("345345345345",factoryId)
      // this.tempfactoryId = factoryId
    },
    /**
     * 厂区切换后赋值
     */
    changeFactoryData(factoryId) {
      console.log("this.factoryData", this.factoryData)
      // if(!factoryId){
      //   this.newAddData.factoryAddressNewId = null
      //   return
      // }
      this.factoryData.forEach(item => {
        if (item.id == factoryId) {
          this.backFactoryId = factoryId
          this.newAddData.factoryAddressNewId = factoryId ? factoryId : null
          this.newAddData.factoryAddressNew = item.fullAddress
          // console.log(this.newAddData.factoryAddressNew,item)
          this.videoUrl = item.liveAddress
          this.videoAccessToken = item.accessToken
          // 切换厂区后，改变一些列状态
          this.changeStatusFun()
          // this.iframeOfSrc = `#/toFactoryMonitor?id=${factoryId}&isLive=true&url=${this.videoUrl}&accessToken=${this.videoAccessToken}&supplyCode=${this.supplyCode}&factoryName=${item.factoryName}&detailedAddress=${item.detailedAddress}`
          this.initOfLive()
          // 2023年1月11日 非必填图片也显示图片组件 回传地址 
          // 通知外面change改变
          this.$emit('shipmentfactoryevent', this.newAddData)
          console.log("factoryId=============", factoryId)
        }
      })
    },
    /**
     * 切换厂区后，改变一些列状态
     * changeStatusFun()
     */
    changeStatusFun() {
      // btn不可用
      this.btnCanUse = true
      this.hasPhoto2 = false
      this.hasPhoto3 = false
      // 如果有定时拍照，清除定时拍照
      if (this.countDown2) {
        clearInterval(this.countDown2)
        this.loadingFlag60S2 = false
        this.getCode2 = ''
        this.btnNameOf2 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
      }
      if (this.countDown3) {
        clearInterval(this.countDown3)
        this.loadingFlag60S3 = false
        this.getCode3 = ''
        this.btnNameOf3 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
      }
    },
    getVideoUrlAndAccessToken() {
      // console.log('66666666',this.supplyCode )
      if (!this.supplyCode) {
        this.info(h_i18n('ba695e853cb99ea5390d11f4e14d74e4'))
        return
      }
      return this.$http({
        method: 'post',
        url: '/base/visualeye/searchFactory',//金鹏新接口
        data: { pageNo: 1, pageSize: 100, supplyCode: this.supplyCode },
      }).then((res) => {
        if (res.data.code == '0') {
          this.factoryData = res.data.data.visualEyeDTOList.map(item => {
            item.fullAddress = item.factoryProvince
            if (item.factoryCity) {
              item.fullAddress += item.factoryCity
            }
            if (item.factoryArea) {
              item.fullAddress += item.factoryArea
            }
            if (item.subDistrict) {
              item.fullAddress += item.subDistrict
            }
            if (item.detailedAddress) {
              item.fullAddress += item.detailedAddress
            }
            return item
          })
          // this.count = res.data.data.visualEyeDTOPage.count
          console.log("factoryData===", this.factoryData)
          if (this.paramsData) {
            this.newAddData.factoryAddressNewId = Number(this.paramsData.backFactoryAddressNewId) ? Number(this.paramsData.backFactoryAddressNewId) : null
          }
          console.log("this.newAddData.factoryAddressNewId===", this.newAddData.factoryAddressNewId)
          if (this.newAddData.factoryAddressNewId) {
            // this.changeFactoryData(this.newAddData.factoryAddressNewId)
            this.factoryData.forEach(item => {
              if (item.id == this.newAddData.factoryAddressNewId) {
                this.backFactoryId = this.newAddData.factoryAddressNewId
                this.newAddData.factoryAddressNew = item.fullAddress
                this.videoUrl = item.liveAddress
                this.videoAccessToken = item.accessToken
                // console.log('zheli')
                this.initOfLive()
                // this.btnCanUse = true
              }
            })
          }
        } else {
          // console.log('哪里')

        }
      })
    },
    // 倒计时按钮
    btnPhotoLater(type) {
      if (type === 3) {
        if (this.hasPhoto3) {
          this.info(h_i18n('49e038b421344d4b8cfc75cacdfccf5c'))
          return
        }
        if (this.loadingFlagNow3) {
          this.info({
            title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
            confirmButtonText: h_i18n('e83a256e4f5bb4ff8b3d804b5473217a'),
            cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
            message: h_i18n('defd18250faeaba28be484d85e14c5f6'),
            type: 'error',
            callback: (action) => {
              console.log(action, "----------------------------")
              if (action === "confirm") {
                this.loadingFlagNow3 = false
                // 执行延时拍照
                this.publicPhotoLater(3)
              } else {

              }
            }
          })
        } else {
          this.publicPhotoLater(3)
        }
      } else {
        if (this.hasPhoto2) {
          this.info(h_i18n('49e038b421344d4b8cfc75cacdfccf5c'))
          return
        }
        if (this.loadingFlagNow2) {
          this.info({
            title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
            confirmButtonText: h_i18n('e83a256e4f5bb4ff8b3d804b5473217a'),
            cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
            message: h_i18n('defd18250faeaba28be484d85e14c5f6'),
            type: 'error',
            callback: (action) => {
              console.log(action, "----------------------------")
              if (action === "confirm") {
                this.loadingFlagNow2 = false
                // 执行延时拍照
                this.publicPhotoLater(2)
              } else {

              }
            }
          })
        } else {
          this.publicPhotoLater(2)
        }
      }
    },
    // 立即拍照按钮
    btnPhotoNow(type) {
      if (type === 2) {
        if (this.hasPhoto2) {
          this.info(h_i18n('49e038b421344d4b8cfc75cacdfccf5c'))
          return
        }
        if (this.loadingFlag60S2) {
          this.info({
            title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
            confirmButtonText: h_i18n('e83a256e4f5bb4ff8b3d804b5473217a'),
            cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
            message: h_i18n('644f4ddee6d62e455a23700801a4f586'),
            type: 'error',
            callback: (action) => {
              console.log(action, "----------------------------")
              if (action === "confirm") {
                clearInterval(this.countDown2)
                this.loadingFlag60S2 = false
                this.getCode2 = ''
                this.btnNameOf2 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                // 执行即时拍照
                this.loadingFlagNow2 = true
                this.getPictureFromVideo(22)
              } else {

              }
            }
          })

        } else {
          this.getPictureFromVideo(22)
          this.photoTimeOf2 = new Date().getTime()
        }
      } else {
        if (this.hasPhoto3) {
          this.info(h_i18n('49e038b421344d4b8cfc75cacdfccf5c'))
          return
        }
        if (this.loadingFlag60S3) {
          this.info({
            title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
            confirmButtonText: h_i18n('e83a256e4f5bb4ff8b3d804b5473217a'),
            cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
            message: h_i18n('644f4ddee6d62e455a23700801a4f586'),
            type: 'error',
            callback: (action) => {
              console.log(action, "----------------------------")
              if (action === "confirm") {
                clearInterval(this.countDown3)
                this.loadingFlag60S3 = false
                this.getCode3 = ''
                this.btnNameOf3 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                this.loadingFlagNow3 = true
                this.getPictureFromVideo(32)
              } else {

              }
            }
          })

        } else {
          this.getPictureFromVideo(32)
          this.photoTimeOf3 = new Date().getTime()
        }
      }
    },
    /**
     * 删除照片
     */
    deletePhoto(type) {
      if (type === 2) {
        if (!this.hasPhoto2) {
          this.info(h_i18n('f7d3cd75eb7b0c9244b769af14937fd0'))
          return
        }
        this.info({
          title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
          confirmButtonText: h_i18n('e83a256e4f5bb4ff8b3d804b5473217a'),
          cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
          message: h_i18n('24fef97bb8fa3c61cc1311783d1e7440'),
          type: 'error',
          callback: (action) => {
            console.log(action, "----------------------------")
            if (action === "confirm") {
              this.picUrl2 = null
              this.newAddData.samplePhotoUuid = null
              this.hasPhoto2 = false
              this.photoTimeOf2 = null
              this.$emit('deleteImg', type)
              this.imgUpLoading1 = false
            } else {

            }
          }
        })

      } else {
        if (!this.hasPhoto3) {
          this.info(h_i18n('f7d3cd75eb7b0c9244b769af14937fd0'))
          return
        }
        this.info({
          title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
          confirmButtonText: h_i18n('e83a256e4f5bb4ff8b3d804b5473217a'),
          cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
          message: h_i18n('c539acddb6f695e1a1eb1d58fb61d1fc'),
          type: 'error',
          callback: (action) => {
            console.log(action, "----------------------------")
            if (action === "confirm") {
              this.picUrl3 = null
              this.newAddData.inspectionPocessPhotoUuid = null
              this.hasPhoto3 = false
              this.photoTimeOf3 = null
              this.$emit('deleteImg', type)
              this.imgUpLoading2 = false
            } else {

            }
          }
        })

      }
    },
    /**
     * 视频截图方法
     */
    tackPic(type) {
      player.capturePicture(`${new Date().getTime()}`, (data) => {
        let picBaseTemp = data.base64
        switch (type) {
          case 66:
            this.btnCanUse = false
            // console.log('66666')
            break
          case 21:
            this.picUrl2 = picBaseTemp
            this.picUrl2List = [this.picUrl2]
            this.hasPhoto2 = true
            this.loadingFlagNow2 = false
            this.uploadImgToOss(type)
            break
          case 22:
            this.picUrl2 = picBaseTemp
            this.picUrl2List = [this.picUrl2]
            this.hasPhoto2 = true
            this.loadingFlagNow2 = false
            this.uploadImgToOss(type)
            break
          case 31:
            this.picUrl3 = picBaseTemp
            this.picUrl3List = [this.picUrl3]
            this.hasPhoto3 = true
            this.loadingFlagNow3 = false
            this.uploadImgToOss(type)
            break
          case 32:
            this.picUrl3 = picBaseTemp
            this.picUrl3List = [this.picUrl3]
            this.hasPhoto3 = true
            this.loadingFlagNow3 = false
            this.uploadImgToOss(type)
            break
        }
      });
    },
    /**
     * 截图事件
     * type 21抽样样品延时 22抽样样品即时 31检验过程延时 32检验过程即时
     */
    getPictureFromVideo(type) {
      // 使用本页面方法
      this.tackPic(type)
    },
    /**
     * 上传截图
     * /unload/uploadToOss
     * https://sqm.haier.net/readFile/hmqm/202212/11a0c9f5e82149cbbfcb2034b92721bc.jpeg
     */
    uploadImgToOss(type) {

      let upLoadFile = this.changeImgFromBase64(type)
      if (type === 21 || type === 22) {
        this.imgUpLoading1 = true
        this.$http({
          method: 'post',
          url: '/base/fileUpload/uploadToOss',
          headers: { 'Content-Type': 'multipart/form-data' },
          data: upLoadFile.file,
          cache: false,
          processData: false,
          contentType: false,
        }).then((res) => {
          console.log('调用上传', res)
          if (res.data) {
            this.fileChoose = false
            // this.fileName = this.fileList[0].name
            // this.fileName = this.fileList[0].name
            // this.fileUuid = res.data
            this.newAddData.samplePhotoUuid = res.data // 抽样照片uuid
            this.newAddData.samplePhoto = upLoadFile.name
            this.newAddData.uploadSamplePhotoTime = this.photoTimeOf2
            this.$emit('shipmentfactoryevent', this.newAddData)
          }
          this.imgUpLoading1 = false
        }).catch((err) => {
          this.info(h_i18n('fd09587cab49aa52ae744666e8aa0115'))
          this.imgUpLoading1 = false
        });
      } else {
        this.imgUpLoading2 = true
        this.$http({
          method: 'post',
          // url: '/unload/uploadToOss',
          url: '/base/fileUpload/uploadToOss',
          headers: { 'Content-Type': 'multipart/form-data' },
          data: upLoadFile.file,
          cache: false,
          processData: false,
          contentType: false,
        }).then((res) => {
          if (res.data) {
            this.fileChoose = false
            this.newAddData.inspectionPocessPhotoUuid = res.data // 检验过程照片uuid
            this.newAddData.inspectionPocessPhoto = upLoadFile.name
            this.newAddData.uploadInspectionPocessPhotoTime = this.photoTimeOf3
            this.$emit('shipmentfactoryevent', this.newAddData)
          }
          this.imgUpLoading2 = false
        }).catch((err) => {
          this.info(h_i18n('fd09587cab49aa52ae744666e8aa0115'))
          this.imgUpLoading2 = false
        });
      }

    },
    /**a
     * 截图base64 转 img/ /blob
     */
    changeImgFromBase64(type) {
      if (type === 21 || type === 22) {
        let bstr = atob(this.picUrl2.split(",")[1]);    // atob是将base64编码解码，去掉data:image/png;base64,部分
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        let formData = new FormData()
        let imgInfo = {
          name: `${this.photoTimeOf2}.jpg`
        }
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        let file = new File([u8arr], imgInfo.name, { type: "image/jpg" })
        formData.append("files", file)
        imgInfo.file = formData
        return imgInfo
      } else if (type === 31 || type === 32) {
        let bstr = atob(this.picUrl3.split(",")[1]);    // atob是将base64编码解码，去掉data:image/png;base64,部分
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        let formData = new FormData()
        let imgInfo = {
          name: `${this.photoTimeOf3}.jpg`
        }
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        let file = new File([u8arr], imgInfo.name, { type: "image/jpg" })
        formData.append("files", file)
        imgInfo.file = formData
        // console.log(formData)
        return imgInfo
      }
    },
    /**
     * 视频流
     */
    initOfLive() {
      if (!this.videoAccessToken || !this.videoUrl) {
        this.info(h_i18n('3a584f6812758118527636d765a95f2b'))
        return
      }
      if (player) {
        player.stop()
      }
      player = new EZUIKit.EZUIKitPlayer({
        id: 'video-container', // 视频容器ID
        url: this.videoUrl,
        accessToken: this.videoAccessToken,
        width: 1000,
        height: 600,
        audio: 0,
        handleSuccess: (e) => {
          // console.log(e)
          let i = 0
          let intervalId = setInterval(() => {
            if (!this.btnCanUse) {
              clearInterval(intervalId)
            } else {
              i++
              this.tackPic(66)
              if (i > 50) {
                clearInterval(intervalId)
                this.info({
                  title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
                  confirmButtonText: h_i18n('132c5cdcceb0f1f17c8c088a42959aa4'),
                  cancelButtonText: h_i18n('c9744f45e76d885ae1c74d4f4a934b2e'),
                  message: h_i18n('6812fc7e70f974d2ccc95b33ec806dab'),
                  type: 'error',
                  callback: (action) => {
                    console.log(action, "----------------------------")
                    if (action === "confirm") {
                      clearInterval(intervalId)
                      player.stop()
                      this.loadingFlag60S3 = false
                      this.getCode3 = ''
                      this.btnNameOf3 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                      this.loadingFlag60S2 = false
                      this.getCode2 = ''
                      this.btnNameOf2 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                      this.btnCanUse = true
                      this.initOfLive()
                    } else {
                      clearInterval(intervalId)
                      player.stop()
                      this.loadingFlag60S3 = false
                      this.getCode3 = ''
                      this.btnNameOf3 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                      this.loadingFlag60S2 = false
                      this.getCode2 = ''
                      this.btnNameOf2 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                      this.btnCanUse = true
                    }
                  }
                })
              }
            }
            console.log('循环' + i + '次')
          }, 500);
        },
        handleError: (e) => {
          console.log("萤石错误信息：", e)
          if (e.retcode === 1003) {
            clearInterval(this.countDown3)
            clearInterval(this.countDown2)
            this.info({
              title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
              confirmButtonText: h_i18n('132c5cdcceb0f1f17c8c088a42959aa4'),
              cancelButtonText: h_i18n('c9744f45e76d885ae1c74d4f4a934b2e'),
              message: h_i18n('b69f2f08e04c84e310251638a9bca08a'),
              type: 'error',
              callback: (action) => {
                console.log(action, "----------------------------")
                if (action === "confirm") {
                  player && player.stop()
                  this.loadingFlag60S3 = false
                  this.getCode3 = ''
                  this.btnNameOf3 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                  this.loadingFlag60S2 = false
                  this.getCode2 = ''
                  this.btnNameOf2 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                  this.btnCanUse = true
                  this.initOfLive()
                } else {
                  player && player.stop()
                  this.loadingFlag60S3 = false
                  this.getCode3 = ''
                  this.btnNameOf3 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                  this.loadingFlag60S2 = false
                  this.getCode2 = ''
                  this.btnNameOf2 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                  this.btnCanUse = true
                }
              }
            })
            return
          } else if (e.retcode === 9048) {
            clearInterval(this.countDown3)
            clearInterval(this.countDown2)
            this.info({
              title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
              confirmButtonText: h_i18n('132c5cdcceb0f1f17c8c088a42959aa4'),
              cancelButtonText: h_i18n('c9744f45e76d885ae1c74d4f4a934b2e'),
              message: h_i18n('775fc20a87e123f1e5f1c293f48a456f'),
              type: 'error',
              callback: (action) => {
                console.log(action, "----------------------------")
                if (action === "confirm") {
                  player && player.stop()
                  this.loadingFlag60S3 = false
                  this.getCode3 = ''
                  this.btnNameOf3 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                  this.loadingFlag60S2 = false
                  this.getCode2 = ''
                  this.btnNameOf2 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                  this.btnCanUse = true
                  this.initOfLive()
                } else {
                  player && player.stop()
                  this.loadingFlag60S3 = false
                  this.getCode3 = ''
                  this.btnNameOf3 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                  this.loadingFlag60S2 = false
                  this.getCode2 = ''
                  this.btnNameOf2 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                  this.btnCanUse = true
                }
              }
            })
            return
          } else if (e.retcode === 10002) {
            clearInterval(this.countDown3)
            clearInterval(this.countDown2)
            this.info({
              title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
              confirmButtonText: h_i18n('132c5cdcceb0f1f17c8c088a42959aa4'),
              cancelButtonText: h_i18n('c9744f45e76d885ae1c74d4f4a934b2e'),
              message: h_i18n('2624b6fa5884b08aa7b02f8ebeacbc0d'),
              type: 'error',
              callback: (action) => {
                console.log(action, "----------------------------")
                if (action === "confirm") {
                  player && player.stop()
                  this.loadingFlag60S3 = false
                  this.getCode3 = ''
                  this.btnNameOf3 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                  this.loadingFlag60S2 = false
                  this.getCode2 = ''
                  this.btnNameOf2 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                  this.btnCanUse = true
                  this.initOfLive()
                } else {
                  player && player.stop()
                  this.loadingFlag60S3 = false
                  this.getCode3 = ''
                  this.btnNameOf3 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                  this.loadingFlag60S2 = false
                  this.getCode2 = ''
                  this.btnNameOf2 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                  this.btnCanUse = true
                }
              }
            })
            return
          } else if (e.retcode === 5404) {
            clearInterval(this.countDown3)
            clearInterval(this.countDown2)
            this.info({
              title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
              confirmButtonText: h_i18n('132c5cdcceb0f1f17c8c088a42959aa4'),
              cancelButtonText: h_i18n('c9744f45e76d885ae1c74d4f4a934b2e'),
              message: h_i18n('d2058b9c7e7535637817e6578e0547e9'),
              type: 'error',
              callback: (action) => {
                console.log(action, "----------------------------")
                if (action === "confirm") {
                  player && player.stop()
                  this.loadingFlag60S3 = false
                  this.getCode3 = ''
                  this.btnNameOf3 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                  this.loadingFlag60S2 = false
                  this.getCode2 = ''
                  this.btnNameOf2 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                  this.btnCanUse = true
                  this.initOfLive()
                } else {
                  player && player.stop()
                  this.loadingFlag60S3 = false
                  this.getCode3 = ''
                  this.btnNameOf3 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                  this.loadingFlag60S2 = false
                  this.getCode2 = ''
                  this.btnNameOf2 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                  this.btnCanUse = true
                }
              }
            })
            return
          } else if (e.retcode === 20018) {
            clearInterval(this.countDown3)
            clearInterval(this.countDown2)
            this.info({
              title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
              confirmButtonText: h_i18n('132c5cdcceb0f1f17c8c088a42959aa4'),
              cancelButtonText: h_i18n('c9744f45e76d885ae1c74d4f4a934b2e'),
              message: h_i18n('b634db0fa702e293d3102a254e745b40'),
              type: 'error',
              callback: (action) => {
                console.log(action, "----------------------------")
                if (action === "confirm") {
                  player && player.stop()
                  this.loadingFlag60S3 = false
                  this.getCode3 = ''
                  this.btnNameOf3 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                  this.loadingFlag60S2 = false
                  this.getCode2 = ''
                  this.btnNameOf2 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                  this.btnCanUse = true
                  this.initOfLive()
                } else {
                  player && player.stop()
                  this.loadingFlag60S3 = false
                  this.getCode3 = ''
                  this.btnNameOf3 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                  this.loadingFlag60S2 = false
                  this.getCode2 = ''
                  this.btnNameOf2 = h_i18n('2cfd7acbb504355432476d6c34f491b1')
                  this.btnCanUse = true
                }
              }
            })
            return
          }
          // this.info("摄像设备状态异常，请保持摄像设备正常运行后再次尝试", '失败', {
          //   confirmButtonText: '确定',
          //   type: 'error',
          //   callback:()=>{
          //   }
          // })
          this.info(h_i18n('3a584f6812758118527636d765a95f2b'))
        }
        // template:"pcLive",
      })
    },
    /** 
     * 延迟拍照公共方法
     * i,抽样样品照片	= 2 检验过程照片 = 3
     * */
    publicPhotoLater(i) {
      let countS = 60
      this["loadingFlag60S" + i] = true
      if (this["countDown" + i]) {
        clearInterval(this["countDown" + i])
        countS = 60
      }
      this["countDown" + i] = setInterval(() => {
        if (countS < 1) {
          countS = 60
          this["getCode" + i] = ''
          this["btnNameOf" + i] = h_i18n('2cfd7acbb504355432476d6c34f491b1')
          clearInterval(this["countDown" + i])
          this["loadingFlag60S" + i] = false
          this["photoTimeOf" + i] = new Date()
          if (i === 2) {
            this.getPictureFromVideo(21)
          } else {
            this.getPictureFromVideo(31)
          }
        } else {
          this["btnNameOf" + i] = h_i18n('5e981a65617feb00409ddc70068c2e68')
          this["getCode" + i] = `\u00A0\u00A0\u00A0\u00A0${countS--}s`
        }
      }, 1000)
    },
    /**
     * 截图按钮禁用状态click事件
     */
    btnCantUse() {
      if (this.btnCanUse) {
        if (!this.videoUrl) {
          this.info(h_i18n('8a9866f96c6aab901b9cf52ab44e8389'))
        } else {
          player.stop()
          this.initOfLive()
          this.info(h_i18n('515c34841017059a1d4d450c6ddde432'))
        }
      }
    },
    // 编辑时的回显
    backShowFun() {
      this.startLoading(h_i18n('20be4e8754288a713b9ad759c78ba22b'))
      // setTimeout(() => {
      if (this.paramsData.backFactoryAddress) {
        this.changeFactoryData(Number(this.paramsData.backFactoryAddressNewId))
      }
      // }, 2000);
      this.newAddData.factoryAddressNewId = Number(this.paramsData.backFactoryAddressNewId) ? Number(this.paramsData.backFactoryAddressNewId) : null
      // alert(this.newAddData.factoryAddressNewId)
      this.newAddData.factoryAddressNew = this.paramsData.backFactoryAddressNew
      this.paramsData.backSamplePhotoUuid ? this.picUrl2 = this.paramsData.backSamplePhotoUuid : this.picUrl2 = '='
      this.paramsData.backInspectionPocessPhotoUuid ? this.picUrl3 = this.paramsData.backInspectionPocessPhotoUuid : this.picUrl3 = '='
      this.picUrl2List = [this.paramsData.backSamplePhotoUuid]
      this.picUrl3List = [this.paramsData.backInspectionPocessPhotoUuid]
      this.photoTimeOf2 = this.paramsData.backUploadSamplePhotoTime
      this.photoTimeOf3 = this.paramsData.backUploadInspectionPocessPhotoTime
      this.hasPhoto2 = true
      this.hasPhoto3 = true
      this.newAddData.samplePhotoUuid = this.picUrl2.split("=")[1] // 抽样照片uuid
      this.newAddData.samplePhoto = `${this.photoTimeOf2}.jpg`
      this.newAddData.uploadSamplePhotoTime = this.photoTimeOf2
      this.newAddData.inspectionPocessPhotoUuid = this.picUrl3.split("=")[1]  // 检验过程照片uuid
      this.newAddData.inspectionPocessPhoto = `${this.photoTimeOf3}.jpg`
      this.newAddData.uploadInspectionPocessPhotoTime = this.photoTimeOf3
      if (this.newAddData.samplePhotoUuid == '') {
        this.hasPhoto2 = false
        this.picUrl2 = this.paramsData.backSamplePhotoUuid
        this.picUrl2List = [this.paramsData.backSamplePhotoUuid]
        console.log('没hasPhoto2', this.hasPhoto2)
      } else {
        console.log('有hasPhoto2', this.hasPhoto2)
      }
      if (this.newAddData.inspectionPocessPhotoUuid == '') {
        this.hasPhoto3 = false
        this.picUrl3 = this.paramsData.backInspectionPocessPhotoUuid
        this.picUrl3List = [this.paramsData.backInspectionPocessPhotoUuid]
        console.log('没hasPhoto3', this.hasPhoto3)
      } else {
        console.log('有hasPhoto3', this.hasPhoto3)
      }
      this.closeLoading()
      this.$emit('shipmentfactoryevent', this.newAddData)
    }
  },
  async mounted() {
    // console.log("ShipmentReportOfFactory=====", this.$route.query)
    if (this.$route.query) {
      // console.log(this.$route.query.supplyCode)
      if (this.$route.query.supplyCode) {
        this.supplyCode = this.$route.query.supplyCode
        // console.log(this.supplyCode)
      }
      if (this.$route.query.dataFrom) {
        this.dataFrom = this.$route.query.dataFrom
        if (this.dataFrom == "sqm") {

        } else if (this.dataFrome == "hmqm") {

        }
      }
      if (this.$route.query.flag) {
        this.flag = this.$route.query.flag
        if (this.flag === 'edit') {
          // 编辑
          this.isEditOrAddFlag = true
          // 修改时的截图相关信息回显保存。
          this.backShowFun()
        } else if (this.flag === "add") {
          // 添加
          this.isEditOrAddFlag = true
        } else if (this.flag === "audit") {
          // 审核
          this.isEditOrAddFlag = false
        } else if (this.flag === "check") {
          // 查看
          this.isEditOrAddFlag = false
        }
      }
      if (this.$route.query.factoryAddressNewId) {
        // this.searchData.factoryAddressNewId = this.$route.query.factoryAddressNewId
      }
    }
    this.getaddress()
    await this.getVideoUrlAndAccessToken()
    // this.paramsData.backFactoryAddress
    // if(this.flag === 'edit'){
    //     // console.log('sssssssssssssssssss',this.paramsData)

    //   }
    // this.getZeroFlag()
  },
  unmounted() {
    if (player) {
      player.stop()
      console.log('关闭萤石组件222')
    }
  },
}
</script>

<style scoped lang="scss">
.tdSize {
  visibility: collapse;
}

:deep(.el-icon-loading) {
  padding-right: 0px;
}

:deep(.el-select__caret) {
  padding-right: 0px;
  line-height: 30px;
}
.blueClick {
  color: #165dff;
  text-decoration: none;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  &:hover {
    color: #4080ff;
  }
  &:active {
    color: #0e42d2;
  }
}
</style>